import {
  POWER_BANK_ACTIVE_LOADING,
  POWER_BANK_ACTIVE_ERROR,

  POWER_BANK_ACTIVE_LIST,
  POWER_BANK_ACTIVE_FILTERS,
  POWER_BANK_ACTIVE_FINISH
} from "actions/chargers/activeRent/constants";

const initialState = {
  loading: false,
  errors: [],

  list: [],
  filters: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case POWER_BANK_ACTIVE_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case POWER_BANK_ACTIVE_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case POWER_BANK_ACTIVE_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    case POWER_BANK_ACTIVE_FILTERS:
      return {
        ...state,
        loading: false,
        errors: [],
        filters: action.payload.content,
      };
    case POWER_BANK_ACTIVE_FINISH:
      return {
        ...state,
        list: {
          ...state.list,
          content: (state.list.content || []).filter(item => item.id !== action.payload)
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/chargers/powerBankActiveRentReducer.js